// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".act-form[data-v-6f2a1d06]{height:100%}.iframe_hight[data-v-6f2a1d06]{height:calc(100% - 2.083vw)}.upload_word[data-v-6f2a1d06]{height:2.083vw;position:relative}.upload_word_btn[data-v-6f2a1d06]{text-align:center;background:#409eff;color:#fff;border-radius:.313vw;line-height:2.083vw}.upload_file[data-v-6f2a1d06],.upload_word_btn[data-v-6f2a1d06]{width:6.25vw;height:2.083vw;cursor:pointer}.upload_file[data-v-6f2a1d06]{position:absolute;left:0;top:0;opacity:0}", ""]);
// Exports
module.exports = exports;
